// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"34e3757c","215":"2803cdbb","382":"f6cafdc8","423":"18d3cbeb","481":"66880bbe","548":"55841c5e","557":"6667db31","561":"484d5fc9","636":"a80f4369","650":"b2f86832","693":"91feb6d1","866":"d0a0baf9","868":"ac2159d6","885":"3d1b439c"}[chunkId] + ".chunk.js";
};